import { OrganizationTypeEnum } from "schema"

export const ORGANIZATION_TYPE_TRANSLATIONS = {
  [OrganizationTypeEnum.Freemium]: "backoffice.organizations.table.accountTypes.freemium",
  [OrganizationTypeEnum.Client]: "backoffice.organizations.table.accountTypes.client",
  [OrganizationTypeEnum.Integration]: "backoffice.organizations.table.accountTypes.integration",
  [OrganizationTypeEnum.Partner]: "backoffice.organizations.table.accountTypes.partner",
} as const
